/* ==========================================================================
   SPICY HOME - HEADER
   Opens and closes the mega menus, and the mobile panel. Nothing else.

   Uses pointerover, which bubbles, rather than pointerenter, which does not.
   That distinction matters: with a delegated listener on the header, one
   handler covers every item and it keeps working even if an ancestor opts
   out of hit-testing. The earlier pointerenter version silently never fired.

   The animation is entirely CSS - this only toggles a class, so no script
   runs while anything is moving. Closing is deliberately delayed, because a
   menu that vanishes the instant the pointer crosses a gap feels cheap and
   makes diagonal travel toward a submenu impossible.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__spicyHeader) return;
  window.__spicyHeader = true;

  var CLOSE_DELAY = 220;

  function init() {
    var header = document.querySelector('[data-sh-header]');
    if (!header) return;

    var items = header.querySelectorAll('[data-sh-mega-item]');
    var closeTimer = null;
    var current = null;

    function close(item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('.sh-hdr__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (current === item) current = null;
    }

    function closeAll() {
      Array.prototype.forEach.call(items, close);
      current = null;
    }

    function open(item) {
      window.clearTimeout(closeTimer);
      if (current === item) return;
      if (current) close(current);
      current = item;
      item.classList.add('is-open');
      var trigger = item.querySelector('.sh-hdr__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeAll, CLOSE_DELAY);
    }

    if (items.length) {
      // One delegated handler. The panel lives inside its own <li>, so
      // hovering the panel still resolves to that item and holds it open.
      header.addEventListener('pointerover', function (e) {
        var item = e.target.closest ? e.target.closest('[data-sh-mega-item]') : null;
        if (item) { open(item); } else { scheduleClose(); }
      });

      header.addEventListener('pointerleave', scheduleClose);

      header.addEventListener('focusin', function (e) {
        var item = e.target.closest ? e.target.closest('[data-sh-mega-item]') : null;
        if (item) { open(item); } else { closeAll(); }
      });

      header.addEventListener('focusout', function (e) {
        if (!header.contains(e.relatedTarget)) closeAll();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && current) {
          var trigger = current.querySelector('.sh-hdr__link');
          closeAll();
          if (trigger) trigger.focus();
        }
      });
    }

    /* ---- mobile panel ---- */
    var toggle = header.querySelector('[data-sh-header-toggle]');
    var panel = header.querySelector('.sh-hdr__panel');
    if (!toggle || !panel) return;

    var isOpen = false;
    function setOpen(next) {
      isOpen = next;
      header.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      // spicy-scroll.js watches for this and stops the smooth-scroll engine.
      document.body.style.overflow = isOpen ? 'hidden' : '';
      if (!isOpen) {
        // Reset the accordion so it always reopens collapsed.
        Array.prototype.forEach.call(
          panel.querySelectorAll('.sh-hdr__panel-parent.is-expanded'),
          function (li) {
            li.classList.remove('is-expanded');
            var t = li.querySelector('.sh-hdr__panel-toggle');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        );
      }
    }

    toggle.addEventListener('click', function () { setOpen(!isOpen); });

    // Collapsible sub-menus inside the mobile panel. The chevron button
    // toggles its row; tapping the link itself still navigates.
    panel.addEventListener('click', function (e) {
      var trig = e.target.closest ? e.target.closest('.sh-hdr__panel-toggle') : null;
      if (!trig) return;
      e.preventDefault();
      e.stopPropagation();
      var li = trig.closest('.sh-hdr__panel-parent');
      if (!li) return;
      var expanded = li.classList.toggle('is-expanded');
      trig.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    panel.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) setOpen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('[data-sh-header]')) {
      window.__spicyHeader = false;
      init();
    }
  });
})();
